import React from 'react'
import { useTranslation } from 'react-i18next'
import { Box, EmptyState, RowsSkeletonLoader } from '@node-space/ui-components'
import { Lottie } from 'components/Animations/SimpleLottie'
import { MIN_PAGINATION_SIZE } from 'constants/queries'
import { usePaymentCaseContext } from 'hooks/context/usePaymentCaseContext'
import { usePaymentCaseEmailsQuery } from 'hooks/queries/usePaymentCaseEmailsQuery'
import { PaymentCaseEmail } from './PaymentCaseEmail'
import { PaymentCaseError } from './PaymentCaseError'

export const PaymentCaseEmails = () => {
  const { t } = useTranslation()

  const { paymentCaseId } = usePaymentCaseContext()

  const {
    data: { emails: paymentCaseEmails } = {},
    isPending,
    isError,
  } = usePaymentCaseEmailsQuery(paymentCaseId)

  return (
    <Box>
      {isPending && <RowsSkeletonLoader rows={MIN_PAGINATION_SIZE} />}
      <Box paddingX={20} flex centerChildren>
        {isError && !isPending && (
          <EmptyState
            testId="error-state"
            LottiePlayer={<Lottie src="connection-error" />}
            title={t('paymentSupport.errorHeadline')}
            description={<PaymentCaseError />}
          />
        )}

        {!isPending && !isError && !!paymentCaseEmails?.length && (
          <Box flex gapY={24} className="flex-col-reverse">
            {paymentCaseEmails?.map((paymentCaseEmail, paymentCaseEmailIndex) => (
              <PaymentCaseEmail key={paymentCaseEmailIndex} paymentCaseEmail={paymentCaseEmail} />
            ))}
          </Box>
        )}

        {!isPending && !isError && !paymentCaseEmails?.length && (
          <EmptyState
            testId="empty-state"
            LottiePlayer={<Lottie src="no-data" />}
            title={t('paymentSupport.noCaseEmails')}
          />
        )}
      </Box>
    </Box>
  )
}
